import KpiList from './KpiList';

export default KpiList;
